import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';

function Transactionhistory(){
    const apiUrl = API_URL;
    const [items, setItems] = useState([]);
    const [user, setUser] = useState([]);
    const viewId = useParams();
    const userId = viewId.userid;

    useEffect(() => {
        const getComments = async () => {
          try{
            const postData = {
                userId: userId
            };
            const res = await fetch(`${apiUrl}/admin/transactionhistory`,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            });
            const data = await res.json();
            if(data.status !== 200){
              throw new Error('Data not found');
            }
            setItems(data.data);
            setUser(data.userdata)
          }catch(error){
            console.error('Error ', error)
          }
        };
        getComments();
      }, []);

    return (
        <div className='width90'>
            <h2 className='pageTitle'>View Transaction History</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" action="">
                    <div className="form-group">
                        <label className="control-label col-sm-2 label">Name:</label>
                        <div className="col-sm-4 mt-1">
                            <span>{user.name}</span>
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label">Email:</label>
                        <div className="col-sm-4 mt-1">
                            <span>{user.email}</span>
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label">User Type:</label>
                        <div className="col-sm-4 mt-1">
                            <span>{user.userType}</span>
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label">Total Credits:</label>
                        <div className="col-sm-4 mt-1">
                            <span>{user.totalcoins}</span>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className='col-sm-12 d-flex'>
                            <div className='col-sm-2'>
                                <label className="font-weight-bold">S.No.:</label>
                            </div>
                            <div className='col-sm-3'>
                                <label className="font-weight-bold">Credits:</label>
                            </div>
                            <div className='col-sm-3'>
                                <label className="font-weight-bold">Transaction Type:</label>
                            </div>
                            <div className='col-sm-4'>
                                <label className="font-weight-bold">Transaction date:</label>
                            </div>
                        </div>
                        {/* transaction data */}
                        {
                            items.map((transactdata, index)=>{
                                return(
                                    <div className='col-sm-12 d-flex'>
                                        <div className='col-sm-2 mt-1'>
                                            <label className="font-weight-bold">{index+1}</label>
                                        </div>
                                        <div className='col-sm-3 mt-1'>
                                            <label className="">{transactdata.coins}</label>
                                        </div>
                                        <div className='col-sm-3 mt-1'>
                                            <label className="">{transactdata.tansation_type}</label>
                                        </div>
                                        <div className='col-sm-4 mt-1'>
                                            <label className="">{transactdata.transactiondate}</label>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        {/* transaction data */}
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Transactionhistory;